import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button, Form } from "react-bootstrap";
import { Colors } from "../utils/style";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./login_style.css";

export default function ForgotPassword() {
  const { t } = useTranslation("forgotPassword");
  const navigate = useNavigate();
  const [message, setMessage] = useState<string | null>(null);
  const [messageType, setMessageType] = useState<"success" | "error" | null>(
    null
  );
  const [isSubmitted, setIsSubmitted] = useState(false);

  async function handleRequestReset(email: string) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST_TEST}password-reset/request?email=${encodeURIComponent(
          email
        )}`,
        {
          method: "POST",
        }
      );

      if (response.ok) {
        setMessage(t("RequestSuccess"));
        setMessageType("success");
        setIsSubmitted(true); // Hide email input and submit button
      } else if (response.status === 404) {
        setMessage(t("UserNotFound"));
        setMessageType("error");
      } else {
        const error = await response.json();
        setMessage(`${t("RequestFailed")}: ${error.message}`);
        setMessageType("error");
      }
    } catch (error) {
      console.error("Error during password reset request:", error);
      setMessage(t("RequestFailed"));
      setMessageType("error");
    }
  }

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email(t("InvalidEmail")).required(t("EmailRequired")),
    }),
    onSubmit: (values) => {
      handleRequestReset(values.email);
    },
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
        backgroundColor: Colors.DARK_GRAY,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2 style={{ color: Colors.WHITE, textAlign: "center" }}>
          {t("ForgotPassword")}
        </h2>
        {!isSubmitted &&
        <p style={{ color: Colors.WHITE, textAlign: "center" }}>
          {t("ForgotPasswordDescription")}
        </p>
        }
        {message && (
          <p
            style={{
              color: messageType === "success" ? "green" : "red",
              textAlign: "center",
              marginTop: "1rem",
            }}
          >
            {message}
          </p>
        )}
        {!isSubmitted && (
          <Form onSubmit={formik.handleSubmit}>
            <Form.Group controlId="email">
              <Form.Label style={{ color: Colors.WHITE }}>
                {t("EmailLabel")}
              </Form.Label>
              <Form.Control
                type="email"
                placeholder={t("EmailPlaceholder")}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                isInvalid={formik.touched.email && !!formik.errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.email}
              </Form.Control.Feedback>
            </Form.Group>
            <Button
              type="submit"
              variant="primary"
              style={{ width: "100%", marginTop: "1rem" }}
            >
              {t("SubmitButton")}
            </Button>
          </Form>
        )}
        <Button
          variant="secondary"
          style={{ width: "100%", marginTop: "1rem" }}
          onClick={() => navigate("/login")}
        >
          {t("BackToLogin")}
        </Button>
      </div>
    </div>
  );
}
